import Vue from 'vue'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'

const user = {
  state: {
    token: '',
    id: '',
    name: '',
    corpName: '',
    welcome: '',
    avatar: '',
    roles: [],
    title: '',
    permissions: [],
    info: {},
    socket: {
      isConnected: false,
      reconnectError: false
    },
    messageNum: 0
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_CORPNAME: (state, corpName) => {
      state.corpName = corpName
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_TITLE: (state, title) => {
      state.title = title
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_SOCKET: (state, socket) => {
      state.socket = socket
    },
    SET_MESSAGE_NUM: (state, messageNum) => {
      state.messageNum = messageNum
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const expiresIn = response.data.expires_in
          const token = response.data.access_token
          Vue.ls.set(ACCESS_TOKEN, token, expiresIn * 10000)
          commit('SET_TOKEN', token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const res = response.data
          console.log(res, 'res')
          if (res.roles && res.roles.length > 0) {
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            reject(new Error('您的账号没有权限进入!'))
          }

          commit('SET_ID', res.id)
          commit('SET_NAME', { name: res.realname, welcome: welcome() })
          commit('SET_CORPNAME', res.corpName)
          if (res.avatarUrl) {
            commit('SET_AVATAR', res.avatarUrl)
          } else {
            commit('SET_AVATAR', require('@/assets/default-avatar.jpg'))
          }
          commit('SET_TITLE', res.title)
          commit('SET_INFO', res)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    SetAvatar ({ commit }, url) {
      commit('SET_AVATAR', url)
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_ID', '')
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_INFO', [])
        Vue.ls.remove(ACCESS_TOKEN)

        logout(state.token).then(() => {
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },

    Connect ({ commit, state }) {
      if (!this.socket || !state.socket.isConnected) {
        this.socket = new WebSocket('wss://auapi.changhongxs.com/rest-api/socket/user/' + state.id + '?access_token=' + state.token)
        this.socket.addEventListener('open', function (event) {
          console.log('✅ Websocket opened.')
          state.socket.isConnected = true
          state.socket.reconnectError = false
          commit('SET_SOCKET', state.socket)
        })
        this.socket.addEventListener('message', function (event) {
          console.log('✅ Websocket received message: %o', event.data)
          const res = JSON.parse(event.data)
          if (res.verb === 'message') {
            commit('SET_MESSAGE_NUM', res.data)
          } else if (res.verb === 'unit') {
          }
        })
        this.socket.addEventListener('error', function (event) {
          console.error('❌ Websocket caught an error: %o', event)
        })
        this.socket.addEventListener('close', function (event) {
          console.log('❌ Websocket closed: %o', event)
          state.socket.isConnected = false
          commit('SET_SOCKET', state.socket)
        })
      }
    },

    FetchMessageNum ({ commit, state }) {
      return new Promise((resolve, reject) => {
        const message = JSON.stringify({ requestType: 'MESSAGE', params: 'count' })
        try {
          if (this.socket && state.socket.isConnected) {
            this.socket.send(message)
          } else {
            this.dispatch('Connect')
          }
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    }

  }
}

export default user
